import DefaultApolloClient from "apollo-boost";

export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api";

const client = new DefaultApolloClient({
  uri: API_URL,
});

export default client;
